import { LicenseManager } from 'ag-grid-enterprise';

/**
 * Kempower has purchased 3 x Developer licenses and 1 x Production instance license of AG Grid (ag-grid.com) on 23.3.2022.
 */
const LICENSE_KEY =
    'CompanyName=Kempower Oyj,LicensedApplication=Kempower ChargEye,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=3,LicensedProductionInstancesCount=1,AssetReference=AG-026573,ExpiryDate=23_March_2023_[v2]_MTY3OTUyOTYwMDAwMA==00226dc532784fd70dfda844d8d74df4';
LicenseManager.setLicenseKey(LICENSE_KEY);
